module.exports = SharedDependencies.ReactDOM['org_hub_shell'];